export const cloudCommandsStyles = {
  console: {
    height: '50vh',
    overflow: 'auto',
    border: '1px solid #E0E0E0',
    borderRadius: '4px',
    mt: 2,
    gap: 0.5,
  },
  commandInput: {
    width: '90%',
    mr: 2,
  },
  createButton: {
    marginTop: 5,
  },
  commandRow: { alignItems: 'center' },
  commandBox: { whiteSpace: 'pre-wrap', px: 1 },
  deleteIconContainer: {
    position: 'absolute',
    alignSelf: 'flex-end',
  },
};
